import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionSnowTire"
const OptionSnowTireIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.804 18.07a1 1 0 0 0 .521 1.93l2.189-.59-.59 2.19a1 1 0 1 0 1.93.52l.57-2.19 1.62 1.61c.38.39 1.03.39 1.42 0 .39-.39.39-1.04 0-1.42l-1.61-1.62 2.19-.57a1 1 0 0 0-.52-1.93l-2.19.59.59-2.19a1 1 0 1 0-1.93-.52l-.57 2.19-1.62-1.61c-.38-.39-1.03-.39-1.42 0-.39.4-.39 1.04 0 1.42l1.61 1.62zm-.227-5.493a1.75 1.75 0 1 0-1.067 1.073c.125-.215.278-.418.46-.604.186-.185.39-.342.607-.469zm2.876-.091c.135-.206.293-.392.47-.556A5 5 0 1 0 11.856 17c.162-.176.346-.334.55-.468l.005-.007a3.008 3.008 0 0 1-.161-2.298 2.25 2.25 0 1 1 1.904-1.909 3.025 3.025 0 0 1 2.303.166zm4.744-.348a1 1 0 0 1 .656 1.06l-.014.112a3.011 3.011 0 0 0-.642-1.172zm-8 9.769a.898.898 0 0 1-.164.032 9.985 9.985 0 0 1-1.11.061h-.003l-.214-.002a1 1 0 0 1-.975-1.076 8.845 8.845 0 0 1-.942-.177l-.017.054a1 1 0 0 1-1.283.595 9.806 9.806 0 0 1-1.021-.439 1.002 1.002 0 0 1-.45-1.342c.01-.016.018-.033.027-.049a9.236 9.236 0 0 1-.885-.651 1 1 0 0 1-1.453.01 10.17 10.17 0 0 1-.723-.843 1 1 0 0 1 .23-1.434 8.83 8.83 0 0 1-.477-.903 1 1 0 0 1-1.315-.618 9.894 9.894 0 0 1-.287-1.075.999.999 0 0 1 .774-1.183l.055-.01a9.334 9.334 0 0 1-.04-.857c0-.06 0-.119.002-.179a1 1 0 0 1-.917-1.127c.048-.369.116-.733.205-1.092a1 1 0 0 1 1.264-.717c.114-.311.246-.613.392-.907a.999.999 0 0 1-.341-1.412c.2-.311.42-.61.654-.897a1 1 0 0 1 1.449-.104c.246-.241.506-.467.777-.678l-.03-.046a1 1 0 0 1 .33-1.375c.317-.194.644-.37.98-.527a1.001 1.001 0 0 1 1.33.482c.008.017.014.034.02.051.325-.11.657-.201.995-.273l-.007-.055a1 1 0 0 1 .896-1.095 10.411 10.411 0 0 1 1.11-.048 1 1 0 0 1 .99 1.01l-.002.055c.318.039.633.094.94.166a1 1 0 0 1 1.293-.664c.35.124.693.267 1.027.428a1 1 0 0 1 .437 1.386c.312.196.61.411.895.643.01-.013.025-.026.038-.039A.999.999 0 0 1 19.065 5c.26.264.504.543.732.834a1 1 0 0 1-.214 1.437c.179.289.342.589.488.899l.052-.02a1 1 0 0 1 1.269.625c.12.35.22.708.299 1.07a1 1 0 0 1-.817 1.202c.029.27.045.544.049.82a2.969 2.969 0 0 0-1.207-.633 2.986 2.986 0 0 0-1.83.098 6 6 0 1 0-6.63 6.632 2.988 2.988 0 0 0-.096 1.837 2.976 2.976 0 0 0 2.037 2.106z" />
    </svg>
  )
}
export default OptionSnowTireIcon
